/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPASSETTYPE } from './IAPASSETTYPE';
import {
    IAPASSETTYPEFromJSON,
    IAPASSETTYPEFromJSONTyped,
    IAPASSETTYPEToJSON,
} from './IAPASSETTYPE';

/**
 * 
 * @export
 * @interface InvestmentDetailsJustIncomeAssetSplitViewModel
 */
export interface InvestmentDetailsJustIncomeAssetSplitViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustIncomeAssetSplitViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustIncomeAssetSplitViewModel
     */
    productJustPortfolioId?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustIncomeAssetSplitViewModel
     */
    assetCode: number;
    /**
     * 
     * @type {IAPASSETTYPE}
     * @memberof InvestmentDetailsJustIncomeAssetSplitViewModel
     */
    assetTypeId?: IAPASSETTYPE;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsJustIncomeAssetSplitViewModel
     */
    splitPercentage?: number;
}

/**
 * Check if a given object implements the InvestmentDetailsJustIncomeAssetSplitViewModel interface.
 */
export function instanceOfInvestmentDetailsJustIncomeAssetSplitViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetCode" in value;

    return isInstance;
}

export function InvestmentDetailsJustIncomeAssetSplitViewModelFromJSON(json: any): InvestmentDetailsJustIncomeAssetSplitViewModel {
    return InvestmentDetailsJustIncomeAssetSplitViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsJustIncomeAssetSplitViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsJustIncomeAssetSplitViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'productJustPortfolioId': !exists(json, 'ProductJustPortfolioId') ? undefined : json['ProductJustPortfolioId'],
        'assetCode': json['AssetCode'],
        'assetTypeId': !exists(json, 'AssetTypeId') ? undefined : IAPASSETTYPEFromJSON(json['AssetTypeId']),
        'splitPercentage': !exists(json, 'SplitPercentage') ? undefined : json['SplitPercentage'],
    };
}

export function InvestmentDetailsJustIncomeAssetSplitViewModelToJSON(value?: InvestmentDetailsJustIncomeAssetSplitViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'ProductJustPortfolioId': value.productJustPortfolioId,
        'AssetCode': value.assetCode,
        'AssetTypeId': IAPASSETTYPEToJSON(value.assetTypeId),
        'SplitPercentage': value.splitPercentage,
    };
}

